import React, { useState } from "react";
import { Menu, MenuItem, Button, Avatar, Typography, Box } from "@mui/material";
import { Check } from "@mui/icons-material";
import { NetworkBase, NetworkEthereum } from "@token-icons/react";
import { useWallet } from "WalletProvider";

const networks = [
  { id: 8453, name: "Base", icon: <NetworkBase sx={{ width: 24, height: 24 }}/> },
  // { id: 1, name: "Etherium", icon: <NetworkEthereum sx={{ width: 24, height: 24 }}/> },
];

const NetworkSelector = () => {
  const { selectedChain, changeNetwork } = useWallet();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = async (network) => {
    
    
    if (!network || !network.id) {
      console.error("Invalid network selected:", network);
      return;
    }

    await changeNetwork(network);
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        onClick={handleClick}
        sx={{
          color: "white",
          textTransform: "none",
          borderRadius: "8px",
          padding: "8px 16px",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        {networks.find((n) => n.id === selectedChain)?.icon || "🌐"}
 
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          sx: {
            bgcolor: "#222",
            color: "white",
            borderRadius: "8px",
            minWidth: "200px",
          },
        }}
      >
        {networks.map((network) => (
          <MenuItem
            key={network.id}
            onClick={() => handleClose(network)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              "&:hover": { bgcolor: "#333" },
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
            {network.icon}
              
              <Typography>{network.name}</Typography>
              {network.isNew && (
                <Typography
                  variant="caption"
                  sx={{
                    bgcolor: "purple",
                    color: "white",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    fontSize: "10px",
                    ml: 1,
                  }}
                >
                  New
                </Typography>
              )}
            </Box>
            {selectedChain === network.id && <Check sx={{ color: "green" }} />}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default NetworkSelector;
